import clamp from 'clamp';
import { modifier } from 'ember-modifier';

interface ClampConfig {
  clamp: number;
  useNativeClamp?: boolean;
}

export default modifier((element: HTMLElement, [lineCount]: [number], namedArgs: { useNativeClamp?: boolean }) => {
  let useNativeClamp: boolean = namedArgs.useNativeClamp ?? true;

  let options: ClampConfig = {
    clamp: lineCount,
    useNativeClamp,
  };

  clamp(element, options);
});
